// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*=============={ Estilos para los botones}=======================*/


/* Grupo de botones de nuevo, edit, eliminar y consult  */
.left-buttons{
    display: flex;  /* Este es para alinear botones en fila */
    margin-right: auto;
    
}

.left-buttons button {
    padding: 0.5em; /* Ajusta el espacio interno */
    font-size: 0.85rem; /* Reduce el tamaño del texto  */
}


/* Grupo de botones de guardar y cancelar  */
.right-buttons {
    display: flex;
    margin-left: auto; 
}

.right-buttons button {
    padding: 0.5em; 
    font-size: 0.85rem;
}


/* QUERY PARA OCULTAR EL TEXTO Y SOLO MOSTRAR LOS ICONOS EN DISPOSITIVOS MOVIL */
@media only screen and (max-width: 490px) {
    /* Ocultar el texto dentro del boton */
    .FormABC-header-btns .p-button {
        font-size: 0; 
    }

    /* Mantener los iconos visibles */
    .FormABC-header-btns .p-button-icon {
        font-size: 1rem; 
    }

    /* Ajustar tamaño del boton para iconos */
    .FormABC-header-btns .p-button {
        padding: 0.5em;
        text-align: center;
        width: 40px; 
        justify-content: center;
    }
}


@media only screen and (max-width: 390px) {
    /* Ocultar el texto dentro del boton */
    .FormABC-header-btns .p-button {
        font-size: 0; 
    }

    /* Mantener los iconos visibles */
    .FormABC-header-btns .p-button-icon {
        font-size: 1rem; 
    }

    /* Ajustar tamaño del boton para iconos */
    .FormABC-header-btns .p-button {
        padding: 0.5em;
        text-align: center;
        width: 40px; 
        justify-content: center;
    }
}





/*=============={ Estilos para los textbox y labels}=======================*/
.grid {
    display: flex;
    flex-direction: column; 
    margin-bottom: 1rem; /* Espaciado entre cada grupo de label y text box */
}

label {
    margin-bottom: 3px; /* Espaciado entre el label y el text box */
    font-weight: bold; 
    display: block; 
}

.clave-input {
    width: 80px;
}

.nombre-input{
    width: 250px;
}



/*=============={ Estilos extra para Formulario Sucursales }=======================*/

.IP-input{
    width: 250px;
}




/*=============={ Estilos extra para Formulario Usuarios }=======================*/
.usuario-input{
    width: 250px;
}

.password-input{
    width: 250px;
}




/*=============={ Estilos extra para Formulario Sublineas }=======================*/


`, "",{"version":3,"sources":["webpack://./src/Css/Botones/botones.css"],"names":[],"mappings":"AAAA,mEAAmE;;;AAGnE,yDAAyD;AACzD;IACI,aAAa,GAAG,yCAAyC;IACzD,kBAAkB;;AAEtB;;AAEA;IACI,cAAc,EAAE,8BAA8B;IAC9C,kBAAkB,EAAE,gCAAgC;AACxD;;;AAGA,4CAA4C;AAC5C;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;;AAGA,gFAAgF;AAChF;IACI,sCAAsC;IACtC;QACI,YAAY;IAChB;;IAEA,iCAAiC;IACjC;QACI,eAAe;IACnB;;IAEA,yCAAyC;IACzC;QACI,cAAc;QACd,kBAAkB;QAClB,WAAW;QACX,uBAAuB;IAC3B;AACJ;;;AAGA;IACI,sCAAsC;IACtC;QACI,YAAY;IAChB;;IAEA,iCAAiC;IACjC;QACI,eAAe;IACnB;;IAEA,yCAAyC;IACzC;QACI,cAAc;QACd,kBAAkB;QAClB,WAAW;QACX,uBAAuB;IAC3B;AACJ;;;;;;AAMA,4EAA4E;AAC5E;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,mDAAmD;AAC5E;;AAEA;IACI,kBAAkB,EAAE,2CAA2C;IAC/D,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;;;AAIA,oFAAoF;;AAEpF;IACI,YAAY;AAChB;;;;;AAKA,kFAAkF;AAClF;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;;;;AAKA,mFAAmF","sourcesContent":["/*=============={ Estilos para los botones}=======================*/\r\n\r\n\r\n/* Grupo de botones de nuevo, edit, eliminar y consult  */\r\n.left-buttons{\r\n    display: flex;  /* Este es para alinear botones en fila */\r\n    margin-right: auto;\r\n    \r\n}\r\n\r\n.left-buttons button {\r\n    padding: 0.5em; /* Ajusta el espacio interno */\r\n    font-size: 0.85rem; /* Reduce el tamaño del texto  */\r\n}\r\n\r\n\r\n/* Grupo de botones de guardar y cancelar  */\r\n.right-buttons {\r\n    display: flex;\r\n    margin-left: auto; \r\n}\r\n\r\n.right-buttons button {\r\n    padding: 0.5em; \r\n    font-size: 0.85rem;\r\n}\r\n\r\n\r\n/* QUERY PARA OCULTAR EL TEXTO Y SOLO MOSTRAR LOS ICONOS EN DISPOSITIVOS MOVIL */\r\n@media only screen and (max-width: 490px) {\r\n    /* Ocultar el texto dentro del boton */\r\n    .FormABC-header-btns .p-button {\r\n        font-size: 0; \r\n    }\r\n\r\n    /* Mantener los iconos visibles */\r\n    .FormABC-header-btns .p-button-icon {\r\n        font-size: 1rem; \r\n    }\r\n\r\n    /* Ajustar tamaño del boton para iconos */\r\n    .FormABC-header-btns .p-button {\r\n        padding: 0.5em;\r\n        text-align: center;\r\n        width: 40px; \r\n        justify-content: center;\r\n    }\r\n}\r\n\r\n\r\n@media only screen and (max-width: 390px) {\r\n    /* Ocultar el texto dentro del boton */\r\n    .FormABC-header-btns .p-button {\r\n        font-size: 0; \r\n    }\r\n\r\n    /* Mantener los iconos visibles */\r\n    .FormABC-header-btns .p-button-icon {\r\n        font-size: 1rem; \r\n    }\r\n\r\n    /* Ajustar tamaño del boton para iconos */\r\n    .FormABC-header-btns .p-button {\r\n        padding: 0.5em;\r\n        text-align: center;\r\n        width: 40px; \r\n        justify-content: center;\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n/*=============={ Estilos para los textbox y labels}=======================*/\r\n.grid {\r\n    display: flex;\r\n    flex-direction: column; \r\n    margin-bottom: 1rem; /* Espaciado entre cada grupo de label y text box */\r\n}\r\n\r\nlabel {\r\n    margin-bottom: 3px; /* Espaciado entre el label y el text box */\r\n    font-weight: bold; \r\n    display: block; \r\n}\r\n\r\n.clave-input {\r\n    width: 80px;\r\n}\r\n\r\n.nombre-input{\r\n    width: 250px;\r\n}\r\n\r\n\r\n\r\n/*=============={ Estilos extra para Formulario Sucursales }=======================*/\r\n\r\n.IP-input{\r\n    width: 250px;\r\n}\r\n\r\n\r\n\r\n\r\n/*=============={ Estilos extra para Formulario Usuarios }=======================*/\r\n.usuario-input{\r\n    width: 250px;\r\n}\r\n\r\n.password-input{\r\n    width: 250px;\r\n}\r\n\r\n\r\n\r\n\r\n/*=============={ Estilos extra para Formulario Sublineas }=======================*/\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
